import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LoyalticInterceptor } from './core/interceptor/interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { BlockedComponent } from './components/blocked/blocked.component';
import { FbShareComponent } from './components/fb-share/fb-share.component';
import { FbsharesuccessComponent } from './components/fb-share/fbsharesuccess/fbsharesuccess.component';
import { FeedbackSuccessComponent } from './components/feedback-success/feedback-success.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { HomeComponent } from './components/home/home.component';
import { LayoutComponent } from './components/layout/layout.component';
import { NickNameComponent } from './components/nick-name/nick-name.component';
import { PlayComponent } from './components/play/play.component';
import { RankingComponent } from './components/ranking/ranking.component';
import { SharedModule } from './components/shared/shared.module';
import { UpdateAddressSuccessComponent } from './components/update-address-success/update-address-success.component';
import { UpdateAddressComponent } from './components/update-address/update-address.component';
import { UploadComponent } from './components/upload/upload.component';
import { WinnersComponent } from './components/winners/winners.component';
import { Loyaltic } from './core/helpers/api-url.constants';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { FooterComingsoonComponent } from './components/coming-soon/footer-comingsoon/footer-comingsoon.component';
import { HeaderComingsoonComponent } from './components/coming-soon/header-comingsoon/header-comingsoon.component';
import { CampaignEndedComponent } from './components/campaign-ended/campaign-ended.component';
import { CreateTournamentComponent } from './components/create-tournament/create-tournament.component';
import { TournamentListComponent } from './components/tournament-list/tournament-list.component';
import { JoinTournamentComponent } from './components/join-tournament/join-tournament.component';
import { TouchSelectDirective } from 'src/app/components/shared/ui/touch-select.directive';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CarouselModule} from 'ngx-owl-carousel-o';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CaptureImageComponent } from './components/capture-image/capture-image.component';
import { WebcamModule } from 'ngx-webcam';
import { BrowserDetectionService } from './services/browser-detection.service';
import { DigitalWinComponent } from './components/play/win/digital-win/digital-win.component';
import { DeliverableWinComponent } from './components/play/win/deliverable-win/deliverable-win.component';
import { WinComponent } from './components/play/win/win.component';
import { NoWinComponent } from './components/play/no-win/no-win.component';
import { GenericPopUpComponent } from './components/generic-pop-up/generic-pop-up.component';
import { CashbackComponent } from './components/cashback/cashback.component';
import { EmailReminderComponent } from './components/shared/email-reminder/email-reminder.component';
import { RegisterComponent } from './components/register/register.component';
import { ReportComponent } from './components/report/report.component';
import {
  RecaptchaModule,
  RecaptchaFormsModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings
} from 'ng-recaptcha';

const RECAPTCHA_V2_DUMMY_KEY = '6LfD1hYsAAAAAGjk6Jx6Vyy5tHHiq6brYSrwuU2L';




export class CustomLoader implements TranslateLoader {

  constructor(private http: HttpClient) { }
  getTranslation(lang: string): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.LocalizationByCulture + '?culture=' + lang).pipe(map(
      (res: any) => {
        const translation = {};
        res.forEach(element => {
          translation[element.key] = element.text;
        });
        return translation;
      })
    );
  }
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, environment.langJsonPath + '/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LayoutComponent,
    NickNameComponent,
    RankingComponent,
    PlayComponent,
    FbShareComponent,
    UploadComponent,
    WinnersComponent,
    FbsharesuccessComponent,
    FeedbackComponent,
    FeedbackSuccessComponent,
    UpdateAddressComponent,
    UpdateAddressSuccessComponent,
    BlockedComponent,
    FooterComingsoonComponent,
    HeaderComingsoonComponent,
    ComingSoonComponent,
    CampaignEndedComponent,
    CreateTournamentComponent,
    TournamentListComponent,
    JoinTournamentComponent,
    TouchSelectDirective,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    CarouselComponent,
    CaptureImageComponent,
    DigitalWinComponent,
    DeliverableWinComponent,
    WinComponent,
    NoWinComponent,
    GenericPopUpComponent,
    CashbackComponent,
    RegisterComponent,
    EmailReminderComponent,
    ReportComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot({ preventDuplicates: true }),
    HttpClientModule,
    FormsModule,
    CarouselModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.52)',
      // backdropBorderRadius: '4px',
      primaryColour: '#fff',
      secondaryColour: '#fff',
      tertiaryColour: '#fff'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomLoader,
        deps: [HttpClient]
      }
    }),
    SharedModule,
    WebcamModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoyalticInterceptor, multi: true },
    { provide: 'ImagePath', useValue: environment.imagePath },
    BsModalRef,
    // { provide: 'googleTagManagerId', useValue: 'GTM-THB85GF' },
    DatePipe,
    BrowserDetectionService,
    CookieService,
     {
        provide: RECAPTCHA_SETTINGS,
        useValue: {
          siteKey: RECAPTCHA_V2_DUMMY_KEY
        } as RecaptchaSettings
      },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
